import React from 'react'
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Card, Icon, Menu } from 'semantic-ui-react'
import { refreshEntities } from "../../actions/entities";
import { deleteEntity } from "../../actions/entities";
import { destroyEntity } from "../../actions/entities";
import Popup from "../../popup-with-modal";
import ui from "../../redux-ui.jsx";
import { findEntity } from "../../selectors/entities/index.js";
import EditModal from "../forms/EditModal";
import EventForm from "./EventForm";

class Event extends React.Component {
  componentDidMount() {
  }

  onClose() {
    this.props.updateUI('eventOpen', null);
  }

  render() {
    const { event, consultation, patient} = this.props
    const dossierId = consultation?.dossierId
    let open = (this.props.ui.eventOpen === event.id)
    return (
      <div>
        <Popup as={'div'} on="click" position="bottom right" style={{ padding: '0em' }}
               open={open} onClose={() => this.onClose()}
               trigger={<div>
                 {consultation && consultation.consultationType && event.linking_status !== 'ignored' ?
                   <Icon name={consultation.consultationType.icon}/>
                   : null
                 }
                 {event.summary}
               </div>}>
          <Card fluid>
            <Card.Content>
              <Card.Header  className={ dossierId && "clickable-card-header"} as={ dossierId && NavLink } to={dossierId && Routes.dossier_path({id: dossierId, _options: true})}>
                {event.summary}
              </Card.Header>
              <Card.Meta>
                <div>
                  <Icon name="clock"/>
                  {event.startTime && I18n.l("time.formats.hour", event.startTime)}
                  -
                  {event.endTime && I18n.l("time.formats.hour", event.endTime)}
                </div>
              </Card.Meta>
              {consultation && consultation.location ?
                <Card.Meta>
                  <Icon name="map marker alternate"/>
                  {consultation.location.name}
                </Card.Meta>
                : null}
              {consultation && consultation.consultationType ?
                <Card.Description>
                  {consultation.consultationType.name}
                </Card.Description> : null}

              {patient ?
                <Card.Description>
                  {I18n.t('components.event.linked_dossier') + patient.firstName + " " + patient.lastName}
                </Card.Description> : null}
            </Card.Content>
            <Card.Content extra>
              <Menu compact icon borderless secondary size="large">
                <EditModal entityName="event"
                           entityId={event.id}
                           EntityForm={EventForm}
                />
                <Menu.Item icon='trash' onClick={this.props.destroyEvent}/>
              </Menu>
            </Card.Content>
          </Card>
        </Popup>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let consultationId = ownProps.event.consultationId
  let consultation = findEntity(state, "consultation", consultationId)
  if(consultation && consultation.deleted) consultation = null
  let dossier = consultation ? findEntity(state, "dossier", consultation.dossierId) : null
  let patient = dossier ? findEntity(state, "contact", dossier.patientId) : null

  return {
    consultation: consultation,
    patient: patient
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    destroyEvent: () => {
      let event = ownProps.event
      dispatch(destroyEntity('event', event.id)).then(
        () => {
          dispatch(refreshEntities('notifications', {name: 'menuItem', filter: {}, page: 1},
                                   ['eventDossierTag', 'generateConsultationError', 'eventConsultationTypeTag', 'eventLocationTag']));
        })
      dispatch(deleteEntity('event', event.id, false))
      event.consultationId && dispatch(deleteEntity('consultation', event.consultationId, false))
    }
  }
}


export default ui({ key: 'eventsCalendar' })(connect(mapStateToProps, mapDispatchToProps)(Event));


